import React from 'react';
import Info from '../../info';
import { NetworkTypes } from '../../../../constants/networkTypes.js';

export default function CallerEntryRightBottomPanel(props) {
  return (
    <div className="mrtl">
      <Info
        paragraphs={[
          APP.LANGUAGE.CallerEntryModal.InfoPartOne.replace(
            '##rcPageUrl##',
            window.APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpUseAABtn
          ),
          APP.LANGUAGE.CallerEntryModal.InfoPartTwo,
          APP.LANGUAGE.CallerEntryModal.InfoPartThree,
          props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation
            ? ''
            : APP.LANGUAGE.CallerEntryModal.InfoPartFour,
        ]}
      />
    </div>
  );
}
